var render, staticRenderFns
import script from "./Scatter.vue?vue&type=script&lang=js&"
export * from "./Scatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80f86946')) {
      api.createRecord('80f86946', component.options)
    } else {
      api.reload('80f86946', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/Charts/Scatter.vue"
export default component.exports